import getCsrfToken from 'bits/csrf_token'
import { fetchJson, FetchError, FetchOptions } from '@padlet/fetch'
import window from 'bits/global'
import { sleep } from 'bits/sleep'

const apiFetchJson = async (url: string, options: FetchOptions = {}): Promise<any> => {
  const commonOptions: FetchOptions = {
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
      'X-UID': window.ww.uid,
    },
  }
  return fetchJson<any>(url, commonOptions, options)
}

const fetchJsonWithRetries = async (url: string, options: FetchOptions = {}, maxTries: number = 4): Promise<any> => {
  try {
    return await apiFetchJson(url, options)
  } catch (error) {
    if (maxTries === 1 || error.status < 500) throw error
    await sleep(10, 50)
    return fetchJsonWithRetries(url, options, maxTries - 1)
  }
}

export { apiFetchJson as fetchJson, fetchJsonWithRetries, FetchError }
